// Structured evidence record backing every factual claim in an editorial.
// Mirrors the `editorial_sources` backend table (see editorial-pipeline/db/schema.sql).

export enum SourceType {
  PLATEX_SOLD = 'platex_sold',
  DVLA_AUCTION = 'dvla_auction',
  COLLECTING_CARS = 'collecting_cars',
  ICONIC_AUCTIONEERS = 'iconic_auctioneers',
  REGHISTORY = 'reghistory',
  NUMBERPLATES_ORG = 'numberplates_org',
  GOOGLE_INDEXED = 'google_indexed',
  SOCIAL = 'social',
  PRESS = 'press',
  MANUAL = 'manual',
}

// Licence/permission status for any associated imagery. We store references
// first and only ever render an image when the status is explicitly cleared.
export enum ImageLicenceStatus {
  UNKNOWN = 'unknown',
  REFERENCE_ONLY = 'reference_only',
  PERMISSION_REQUESTED = 'permission_requested',
  LICENCED = 'licenced',
  PUBLIC_DOMAIN = 'public_domain',
  REJECTED = 'rejected',
}

export class EditorialSourceImage {
  public id: number;
  public sourceId: number;
  public imageUrl: string;
  public caption: string;
  public licenceStatus: ImageLicenceStatus;
  public attribution: string;
  // Set once an admin/legal has cleared the image; only then may it render.
  public approvedForDisplay: boolean;
}

export class EditorialSource {
  public id: number;
  public articleId: number;
  public sourceType: SourceType;
  public url: string;
  public title: string;
  public dateAccessed: Date;
  public publishedDate?: Date;
  // Extracted (not verbatim-copied) text used to ground claims.
  public extractedText: string;
  // 0..1 confidence that this source is relevant and reliable for the plate.
  public confidence: number;
  public images: EditorialSourceImage[];
}
